import Cookies from 'js-cookie';

export function emailCapture()  {
	
	const emailCaptureCookie = Cookies.get('characterEmailCapture');
	const emailCaptureBar = document.querySelector('#email-capture-bar');
	const emailCaptureBarClose = document.querySelector('#email-capture-close');

	window.hideEmailCapture = function() {
		window.emailCaptureSetCookie();
		return emailCaptureBar.classList.add('hide-email-capture');
	}
	
	window.emailCaptureSetCookie = function() {
		Cookies.set('characterEmailCapture', 'hide', { expires: 365 })
	}

	window.showEmailCapture = function() {
		if(!emailCaptureBar) {
			return
		}
		
		if (emailCaptureCookie === 'first') {
			emailCaptureBar.classList.remove('animate-email-capture');
		} else {
			Cookies.set('characterEmailCapture', 'first', { expires: 365 })
		}
		emailCaptureBar.classList.remove('hide-email-capture');
	}

	if (emailCaptureBarClose) {
		emailCaptureBarClose.addEventListener('click', (e) => {
			hideEmailCapture();
		})
	}

	if (!emailCaptureCookie || emailCaptureCookie !== 'hide') {
		showEmailCapture();
	}
}